import React, { useState } from 'react'
import { Box } from '@mui/material'
import { intelColors } from './intelTheme'

// Inline copy-to-clipboard glyph with brief ✓ feedback. Stops click propagation so it can sit inside
// clickable rows. Renders nothing when there's no text to copy.
export default function CopyButton({ text, title = 'Copy' }) {
  const [done, setDone] = useState(false)
  if (!text) return null
  return (
    <Box
      component='span'
      role='button'
      title={title}
      onClick={(e) => {
        e.stopPropagation()
        if (navigator.clipboard) {
          navigator.clipboard.writeText(text).then(() => {
            setDone(true)
            setTimeout(() => setDone(false), 1200)
          }).catch(() => {})
        }
      }}
      sx={{ cursor: 'pointer', fontSize: 12, lineHeight: 1, flex: '0 0 auto', userSelect: 'none', color: done ? '#2e7d32' : intelColors.muted, '&:hover': { color: intelColors.primary } }}
    >
      {done ? '✓' : '📋'}
    </Box>
  )
}
